module.exports = __webpack_public_path__ + "img/red_envelopes2.991c041e.png";